import axiosInstance from "./axiosInstance";

const ReportService = {
    search: (page, size, filters) =>
        axiosInstance.post(`/api/reports/search?page=${page}&size=${size}&sort=reportDate,desc`, filters).then(r => r.data),

    getById: (id) =>
        axiosInstance.get(`/api/reports/${id}`).then(r => r.data),
};

export default ReportService;
